import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const TableRow = ({ className, children }) => (
  <tr className={styles.row}>
    {React.Children.map(children, child => (
      <td className={cx(styles.cell, className)}>{child}</td>
    ))}
  </tr>
)

TableRow.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default TableRow
